import { BRAND } from "@/data/content";
import { Phone, MapPin, Mail, MessageCircle, Instagram, Facebook } from "lucide-react";
import { StarDash } from "@/components/StarDash";

const SOCIALS = [
  {
    name: "Instagram",
    href: "https://www.instagram.com/inccleaningservices.kl/",
    Icon: Instagram,
    testid: "social-instagram",
  },
  {
    name: "Facebook",
    href: "https://www.facebook.com/profile.php?id=61590136855804",
    Icon: Facebook,
    testid: "social-facebook",
  },
];

const Footer = () => {
  const year = new Date().getFullYear();
  const waLink = `${BRAND.whatsapp}?text=${BRAND.whatsappText}`;
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#c63027] text-[#fbf3e6] relative overflow-hidden grain"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-6 md:px-10 py-16 sm:py-20">
        {/* Top decorative */}
        <div className="text-center">
          <StarDash color="rgba(251,243,230,0.6)" />
          <div className="mt-8 sm:mt-10 font-display text-6xl sm:text-9xl font-bold tracking-tighter leading-none">
            INC.
          </div>
          <div className="mt-2 sm:mt-3 font-sans-body text-xs sm:text-sm font-semibold uppercase tracking-[0.32em] sm:tracking-[0.42em] text-[#fbf3e6]/85">
            Cleaning Services
          </div>
          <div className="mt-5 mx-auto w-16 h-[2px] bg-[#fbf3e6]" />
          <p className="font-italic-serif mt-5 sm:mt-6 text-xl sm:text-3xl">
            "We Don't Cut Corners,{" "}
            <span className="text-[#fbf3e6]/85">We Clean Them."</span>
          </p>
          <a
            href={waLink}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-whatsapp-btn"
            className="pill-btn mt-8 inline-flex items-center gap-2 h-12 px-7 bg-[#fbf3e6] hover:bg-white text-[#c63027] transition-colors"
          >
            <MessageCircle className="size-4" />
            WhatsApp
          </a>

          {/* Social icons */}
          <div
            className="mt-8 flex items-center justify-center gap-4"
            data-testid="social-icons"
          >
            {SOCIALS.map(({ name, href, Icon, testid }) => (
              <a
                key={name}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`Follow INC. Cleaning Services on ${name}`}
                data-testid={testid}
                className="group size-11 grid place-items-center rounded-full border border-[#fbf3e6]/40 hover:bg-[#fbf3e6] hover:border-[#fbf3e6] transition-colors"
              >
                <Icon className="size-5 text-[#fbf3e6] group-hover:text-[#c63027] transition-colors" />
              </a>
            ))}
          </div>
        </div>

        <div className="mt-16 grid sm:grid-cols-3 gap-10 text-center sm:text-left">
          <div>
            <div className="font-sans-body text-[10px] font-bold uppercase tracking-[0.32em] text-[#fbf3e6]/85">
              ★ Phone
            </div>
            <ul className="mt-4 space-y-2 font-display text-lg">
              {BRAND.phones.map((p) => (
                <li key={p} className="flex sm:items-start items-center justify-center sm:justify-start gap-2">
                  <Phone className="size-4 opacity-70" />
                  {p}
                </li>
              ))}
            </ul>
          </div>
          <div>
            <div className="font-sans-body text-[10px] font-bold uppercase tracking-[0.32em] text-[#fbf3e6]/85">
              ★ Email
            </div>
            <a
              href={`mailto:${BRAND.email}`}
              className="mt-4 inline-flex items-center justify-center sm:justify-start gap-2 font-display text-lg hover:underline"
            >
              <Mail className="size-4 opacity-70" /> {BRAND.email}
            </a>
          </div>
          <div>
            <div className="font-sans-body text-[10px] font-bold uppercase tracking-[0.32em] text-[#fbf3e6]/85">
              ★ Address
            </div>
            <div className="mt-4 flex items-start justify-center sm:justify-start gap-2 font-italic-serif text-base text-[#fbf3e6]/95 leading-relaxed">
              <MapPin className="size-4 opacity-70 mt-1 shrink-0" />
              <span>{BRAND.address}</span>
            </div>
          </div>
        </div>

        <StarDash className="mt-16" color="rgba(251,243,230,0.6)" />

        <div className="mt-10 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-[#fbf3e6]/85 font-sans-body uppercase tracking-[0.2em]">
          <div>© {year} INC. Cleaning Services · All rights reserved</div>
          <div className="inline-flex items-center gap-2">
            <span className="size-1.5 bg-[#fbf3e6]" />
            Reg. {BRAND.registration}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
